// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3RyrW","loaderOuter":"PageOverlayLoader_loaderOuter__1fpff"};